module.exports = __webpack_public_path__ + "img/social-icons.e365a9d9.png";